// extracted by mini-css-extract-plugin
module.exports = {"actions":"RoomForm_actions__2kxDa","wrapper":"RoomForm_wrapper__1OMCQ row","column":"RoomForm_column__2czKp col-lg-6"};